<script lang="ts">

    import {UIElement} from '../../../ui-elements/element';
    import {onMount} from 'svelte';
    import {OriginCoords} from '../../../types';

    export let uiElement: UIElement;
    export let origin: OriginCoords;
    let bind;
    onMount(() => {
        uiElement.convertToUiElement(bind, uiElement, origin)
    });
</script>

<div class="uiListItem config-item border border-accent pb-1.5 pt-1.5" bind:this={bind}>
</div>

<style>

    .config-item {
        width: 23rem;
    }

</style>
